import { useMemo } from "react";
import { Button } from "../../../../ui/button/button";
import { PrintSelectImageData, ThumbImagesDataEntity } from "../hooks/use-print-select-images";
import { FaPlusCircle } from "react-icons/fa";
import { FaMinusCircle } from "react-icons/fa";
import { GrNext } from "react-icons/gr";
import { PrintSelectUseImageCard } from "./print-select-use-images.card";

type Props = {
  list: PrintSelectImageData[],
  open?: boolean,
  onAllIncrement: () => void,
  onAllDecrement: () => void,
  onInputSelect: (id: string, count: number) => void,
  saveThumbImageList: ThumbImagesDataEntity[],
}

export const PrintSelectUseImageList = (props: Props) => {
  const {
    list,
    open,
    saveThumbImageList,
    onAllIncrement,
    onAllDecrement,
    onInputSelect,
  } = props;

  const viewList = useMemo(() => {
    return list.filter((v) => v.count);
  }, [list]);

  return (
    <div className={`print_select_images__footer__image_list ${open ? 'open' : ''}`}>
      <div
        className="print_select_images__footer__image_list__left"
      >
        <Button
          color="light"
          label={(
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', justifyContent: 'center' }}>
              全て一枚増
              <GrNext className="gr_next" />
            </div>
          )}
          icon={<FaPlusCircle />}
          onClick={onAllIncrement}
        />
        <Button
          color="light"
          label={(
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', justifyContent: 'center' }}>
              全て一枚減
              <GrNext className="gr_next" />
            </div>
          )}
          icon={<FaMinusCircle />}
          onClick={onAllDecrement}
        />
      </div>
      <hr key="print_select_images__footer__image_list__left_hr" />
      <div className="print_select_images__footer__image_list__right">
        {
          viewList.map((data) => (
            <PrintSelectUseImageCard
              data={data}
              onInputSelect={onInputSelect}
              key={`use_image_card_${data.id}`}
              saveThumbImageList={saveThumbImageList}
            />
          ))
        }
      </div>
    </div>
  )
}